import styled from 'styled-components'
import { Col as AntCol, Icon as AntIcon, List as AntList } from 'antd'

export const Col = styled(AntCol)`
  text-align: center;
`

export const List = styled(AntList)`
  min-width: 60rem;
` as React.ComponentType as new <T>() => AntList<T>

export const RuleContainer = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  width: 100%;
  margin: 1rem 0;
`

export const Icon = styled(AntIcon)`
  padding: 0.3rem 0 0 0.5rem;
`
